var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDragAndDrop = function SvgDragAndDrop(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 6.747V5.247C16.5 4.41857 15.8284 3.747 15 3.747C14.1716 3.747 13.5 4.41857 13.5 5.247V4.5C13.5 3.67157 12.8284 3 12 3C11.1716 3 10.5 3.67157 10.5 4.5V5.25C10.5 4.42157 9.82843 3.75 9 3.75C8.17157 3.75 7.5 4.42157 7.5 5.25V10.5C5.84315 10.5 4.5 11.8431 4.5 13.5C4.49977 14.9634 4.95711 16.3903 5.808 17.581L6.908 19.116C7.75201 20.2973 9.11414 20.9989 10.566 21H14.379C15.7377 21 17.0407 20.4601 18.0012 19.499C18.9616 18.538 19.5008 17.2347 19.5 15.876V6.747C19.5 5.91857 18.8284 5.247 18 5.247C17.1716 5.247 16.5 5.91857 16.5 6.747Z",
    fill: "#DAD8FF",
    stroke: "#4239FB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 10.497V12.747V10.497Z",
    fill: "#DAD8FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.497V12.747",
    stroke: "#4239FB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 8.99701V5.24701V8.99701Z",
    fill: "#DAD8FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8.99701V5.24701",
    stroke: "#4239FB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 8.99701V5.24701V8.99701Z",
    fill: "#DAD8FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 8.99701V5.24701",
    stroke: "#4239FB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 8.99701V6.74701V8.99701Z",
    fill: "#DAD8FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 8.99701V6.74701",
    stroke: "#4239FB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDragAndDrop);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";